import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";

function handleSuccess(
  state: State,
  { projects }: Boundaries["retrieveZonesProjects"]["success"],
): State {
  return { ...state, request: setRequestStateToSuccess(), projects };
}

export { handleSuccess };
